//-------------Imports-------------//

import wixData from 'wix-data';
import wixLocation from 'wix-location';

//-------------Page Setup-------------//

$w.onReady(async function () {
    // Get the current product's data.
    let product = await $w('#productPage').getProduct();
    // Load the products that are related to the currently displayed product using the loadRelatedProducts() function.
    loadRelatedProducts(product);

    wixLocation.onChange(async (location) => {
        loadRelatedProducts(product);
    });
});

// Load the products that are related to the currently displayed product.
async function loadRelatedProducts(product) {
    // Get the related product results using the relatedProductsByCollection() and relatedProductsByPrice() functions.
    let relatedProductResults = await Promise.all([
        relatedProductsByCollection(product),
        relatedProductsByPrice(product)
    ]);

    // If there are related products found in the "related-products" collection:	
    if (relatedProductResults[0].length > 0){
        // Show the related products from the collection.
        showRelatedProducts(relatedProductResults[0]);
    // If there are no related products found in the "related-products" collection:	
    }else{
        // Fallback to showing the related products by price.
        showRelatedProducts(relatedProductResults[1]);}
}

// Get related products based on the relations set in the "related-products" collection.
async function relatedProductsByCollection(product) {
     console.log((product ? JSON.stringify(product): "product is NULL!"));
    console.log((product._id ? JSON.stringify(product._id): "id is NULL!"));
  let productId = product._id;

  // find related products by relation table
  let relatedByTable = await Promise.all([
      wixData.query('relatedProducts')
      .eq('productA', productId)
      .include('productB')
      .find(),
      wixData.query('relatedProducts')
      .eq('productB', productId)
      .include('productA')
      .find()
  ]);
console.log((relatedByTable ? JSON.stringify(relatedByTable): "rbt is NULL!"));
  let relatedProducts = [
      ...relatedByTable[0].items.map(_ => _.productB),
      ...relatedByTable[1].items.map(_ => _.productA)
  ];
  console.log((relatedProducts ? JSON.stringify(relatedProducts): "rp is NULL!"));
  return relatedProducts;
}

// Get related products based on the the product prices.
async function relatedProductsByPrice(product) {
    // Get the current product's ID.
    let productId = product._id;

    // Query the "Products" collection for product's whose price is within 20% of the current product's price.
    let relatedByPrice = await wixData.query('Stores/Products')
        .between('price', product.price * 0.8, product.price * 1.2)
        .ne('_id', productId)
        .find();
    // Return the related items extracted from the query results.
    return relatedByPrice.items;
}

// Show the related products on the page.
function showRelatedProducts(relatedProducts) {
    // If there are any related products:
    if (relatedProducts.length > 0) {
        // Remove all but the first four related items.
        relatedProducts.splice(3, relatedProducts.length);
        // Set the function that runs when the related items repeater data is loaded to be relatedItemReady().
        $w('#relatedItemsRepeater').onItemReady(relatedItemReady);
        // Set the related items repeater data to the first four related items.
        $w("#relatedItemsRepeater").data = relatedProducts;
        // Expand the related items repeater.
        $w("#relatedItems").expand();
    }
    // If there are no related products:
    else {
        // Collapse the related items repeater.
        $w("#relatedItems").collapse();
    }
}

// Set up the related items repeater as its data is loaded.
function relatedItemReady($item, product) {
    // Populate the repeater elements from the item data.
    console.log((product ? JSON.stringify(product): "item is NULL!"));
    if (product.mainMedia) { 
        $item("#productImage").src = product.mainMedia;
        $item("#productName").text = product.name;
        $item("#productPrice").text = product.formattedPrice;
        // Set the action that occurs when the image is clicked.
        $item('#productImage').onClick(() => {
            // Navigate to the related product's product page.
            wixLocation.to(product.productPageUrl);
        });
    } else {
      $item("#productImage").src = product.productB.mainMedia;
        $item("#productName").text = product.productB.name;
        $item("#productPrice").text = product.productB.formattedPrice;
        // Set the action that occurs when the image is clicked.
        $item('#productImage').onClick(() => {
            // Navigate to the related product's product page.
            wixLocation.to(product.productB.productPageUrl);  
    });
}}